module.exports = __webpack_public_path__ + "static/how-to-create-brand__step-1-419bd80d8a2974255934385f8bdef50b.png";